<template>
  <v-flex class="d-flex align-center">
    <v-text-field
      v-model="inputedValue"
      placeholder="000-0000"
      outlined
      dense
      hide-details
      :height="height"
      class="pr-2"
      :disabled="disabled"
      :filled="disabled"
    >
    </v-text-field>
    <NormalButton
      v-if="isJpn"
      :text="$t('common.input_auto-input')"
      :height="height"
      color="white"
      textColor="thinText--text"
      btnClass="px-3"
      :outlined="true"
      @click="getAddress(inputedValue)"
    />
  </v-flex>
</template>

<script>
import { NormalButton } from '@/components/items'
import { Core as YubinBangoCore } from 'yubinbango-core'
import { countryUtil } from '@/util'
import { langConfig } from '@/config'

export default {
  components: {
    NormalButton
  },
  props: {
    value: {},
    countryId: { default: '' },
    height: { default: '32px' },
    disabled: { default: false }
  },
  data: () => ({
    items: []
  }),
  created() {},
  methods: {
    submit() {
      this.$emit('submit')
    },
    getAddress(yubinbango) {
      if (!this.is_empty(yubinbango) && yubinbango.length >= 7) {
        new YubinBangoCore(yubinbango, (addr) => {
          const address = {
            region: addr.region, // 都道府県
            locality: addr.locality, // 市区町村
            street: addr.street // 町域
          }
          // 日本語以外が設定されている場合は都道府県名をその言語に変換する
          if (this.$i18n.locale != langConfig.LANG_JA) {
            const regionMap = countryUtil.getRegionStrByLang(this.$i18n.locale)
            address.region = regionMap[address.region]
          }
          this.$emit('click', address)
        })
      } else {
        alert(this.$t('common.input_postal-code-alert'))
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    isJpn() {
      return this.countryId == 88
    }
  }
}
</script>
<style scoped lang="scss"></style>
